'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardStore = _reflux2.default.createStore({

    listenables: [_Actions2.default],
    _paymentMethod: {},
    // Add payment method
    addPaymentMethod: function addPaymentMethod(paymentMethod) {
        this._paymentMethod = _lodash2.default.assign({}, this._paymentMethod, paymentMethod);
        this.triggerPaymethodChange();
    },
    resetPaymentMethod: function resetPaymentMethod() {
        this._paymentMethod = {};
        this.triggerPaymethodChange();
    },
    detachPaymentMethod: function detachPaymentMethod(paymentMethodId) {
        if (this._paymentMethod && this._paymentMethod.paymentMethodId == paymentMethodId) {
            this._paymentMethod = {};
            this.triggerPaymethodChange();
        }
    },
    triggerPaymethodChange: function triggerPaymethodChange() {
        this.trigger('change', this._paymentMethod);
    }
});
exports.default = CardStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/CardStore.jsx
// module id = 415
// module chunks = 0